// extracted by mini-css-extract-plugin
export default {"navigation":"Navbar_navigation__mHNH-","list":"Navbar_list__rXC0i"};